export class Services {
    public static authorizationServiceUrl = 'https://keycloak-riadev.staging.adelphis.co:8443/realms/demo';

    public static clearingServiceUrl = 'https://ria-devapi.staging.adelphis.co';
}
